(() => {
  class HeroSlideshow {
    constructor(element) {
      this.element = element;
      this.slides = [...element.querySelectorAll('[data-hero-slide]')];
      this.dots = [...element.querySelectorAll('[data-hero-slide-to]')];
      this.previousButton = element.querySelector('[data-hero-previous]');
      this.nextButton = element.querySelector('[data-hero-next]');
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      this.currentIndex = this.currentIndex === -1 ? 0 : this.currentIndex;
      this.autoplayEnabled = element.dataset.autoplay === 'true' && this.slides.length > 1;
      this.speed = Math.max(Number(element.dataset.speed) || 5, 1) * 1000;
      this.timer = null;

      this.bindControls();
      this.show(this.currentIndex, false);
      this.startAutoplay();
    }

    bindControls() {
      this.previousButton?.addEventListener('click', () => this.show(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.show(this.currentIndex + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.heroSlideTo)));
      });
    }

    show(index, resetAutoplay = true) {
      const slideCount = this.slides.length;
      if (!slideCount) return;

      this.currentIndex = ((index % slideCount) + slideCount) % slideCount;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.toggleAttribute('inert', !isActive);
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });

      if (resetAutoplay) this.restartAutoplay();
    }

    startAutoplay() {
      if (!this.autoplayEnabled) return;

      this.timer = window.setInterval(() => this.show(this.currentIndex + 1, false), this.speed);
    }

    restartAutoplay() {
      if (!this.autoplayEnabled) return;

      window.clearInterval(this.timer);
      this.startAutoplay();
    }
  }

  const initializeHeroSlideshows = (root = document) => {
    root.querySelectorAll('[data-hero-slideshow]').forEach((element) => {
      if (!element.heroSlideshow) element.heroSlideshow = new HeroSlideshow(element);
    });
  };

  const initialize = () => initializeHeroSlideshows();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initializeHeroSlideshows(event.target));

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-hero-slide]');
    const slideshow = slide?.closest('[data-hero-slideshow]');
    if (!slide || !slideshow?.heroSlideshow) return;

    slideshow.heroSlideshow.show(Number(slide.dataset.heroSlide), false);
  });
})();
